import { createFileRoute } from '@tanstack/react-router';
import { CbmBandsPage } from '@/features/admin/system-settings';

export const Route = createFileRoute('/admin/system-settings/cbm-bands/')({
  component: AdminCbmBandsRoute,
});

function AdminCbmBandsRoute() {
  return <CbmBandsPage />;
}
